import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export default {
    // This is used to store an action datapoint with customData, so the customData parameters must match the parameters of the action it is tracking.
    FPAddDataProvider: {
        name: 'FPAddDataProvider',
        customData: (
            redirectUrl: string,
            providerType: AttachmentDataProviderType,
            getAddableFileProviderInfoFunc: (providerType: AttachmentDataProviderType) => any
        ) => [providerType],
    },
};
